import React from "react";
import Table2 from "../Table2/Table2";
import select from "../../images/icons/pointer.png";
import External_In_Map from "../External_Visites/External_In_Map";
import FilterStatistics from "../Main/Statistics/FilterStatistics";
import { useSelectorCustom } from "../General/GeneralComponent/useSelectorCustom";
import {
  ColumnArrayMonthlyOrders,
  VariableReports,
} from "./VariableReports";

function OrdersReport({ langmiamed, t, navigate, setopenInternet }) {
  const { orders, loagingorders } = useSelectorCustom();
  const reversedgeneralExReport = orders?.reverse();
  const { state, storeMap, setIsOpen } = VariableReports();
  const { OrdersReqsColumn } = ColumnArrayMonthlyOrders(t, storeMap);
  return (
    <>
      <FilterStatistics
        t={t}
        langmiamed={langmiamed}
        params="monthly_orders_report"
        excel="monthly_orders_report"
      />
      <div className="users" dir={langmiamed == "ar" ? "ltr" : "ltr"}>
        {loagingorders == false ? (
          <Table2 col={OrdersReqsColumn} roo={reversedgeneralExReport} />
        ) : (
          <div className="alternative">
            <img src={select} />
            <br></br>
            <p>{t("filterr")}</p>
          </div>
        )}
      </div>
      {state.openMap && (
        <External_In_Map
          open={state.openMap}
          setOpen={setIsOpen}
          lat={state.lat}
          lng={state.lng}
        />
      )}
    </>
  );
}

export default OrdersReport;
